// extracted by mini-css-extract-plugin
export var arrows = "_5w-6";
export var decrementer = "_5w-a";
export var disabled = "_5w-4";
export var error = "_5w-1";
export var hiddenText = "_5w-b";
export var incrementer = "_5w-9";
export var input = "_5w-8";
export var inputWrapper = "_5w-0";
export var leadingIcon = "_5w-c";
export var readonly = "_5w-3";
export var regular = "_5w-7";
export var small = "_5w-5";
export var warning = "_5w-2";